import React from 'react';

import Modal from 'components/Modal';

import { Spinner } from 'triider-components';
import {
  ModalBody,
  ContentButtons,
  ButtonModal,
} from '../styles';


function ResponsibleOrder({
  task,
  responsibilitySelected,
  isTaskDetail,
  isOpen,
  closeModal,
  loadingVisibleModal,
  _setResponsibilities,
}) {
  const getStatusText = (status) => {
    switch (status) {
      case 'done':
        return 'finalizado';
      case 'paid':
        return 'pago';
      case 'canceled':
        return 'cancelado';
      case 'hired':
        return 'contratado';
      default:
        return '';
    }
  };

  const changeResponsibility = async () => {
    await _setResponsibilities({ responsibilitySelected, task_id: task.id, ofListTask: !isTaskDetail });
    closeModal();
  };

  return (
    <Modal
      width="548px"
      height="264px"
      title="Definir responsável pelo pedido"
      isOpen={isOpen}
      toggle={closeModal}
      padding="25px"
      paddingheader="30px"
      boldHeader="600"
      textTransform="none"
      borderbottomheader="none"
    >
      {loadingVisibleModal ? (
        <Spinner size="larger" />
      ) : (
        <>
          <ModalBody>
            {task.status === 'open' || task.status === 'charged' ? (
              <>
                Você está definindo o
                {' '}
                <span>{responsibilitySelected.company_responsibility}</span>
                {' '}
                como responsável e passará a gerenciar este pedido.
              </>
            ) : (
              `Pedido ${getStatusText(
                task.status,
              )}, neste estágio não podemos alterar a responsabilidade.`
            )}
          </ModalBody>
          <ContentButtons>
            {task.status === 'open' || task.status === 'charged' ? (
              <ButtonModal type="button" onClick={changeResponsibility}>
                CONFIRMAR
                {' '}
                <b>{responsibilitySelected.company_responsibility}</b>
                {' '}
                COMO REPONSÁVEL
              </ButtonModal>
            ) : null}
            <ButtonModal type="button" onClick={closeModal} isCancel>
              CANCELAR
            </ButtonModal>
          </ContentButtons>
        </>
      )}
    </Modal>
  );
}

export default ResponsibleOrder;
